module.exports = __webpack_public_path__ + "static/PSA_ImplemConsult-9651ed98c58e06760a9d630fa26977f2.png";